module.exports = __webpack_public_path__ + "static/img/保险.5d6c06b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/system/assets/保险.png
// module id = adJD
// module chunks = 3